import { StatusColor } from './statusColor';

export const AD_ACCOUNT_STATUS_MAP = {
  APPROVED: StatusColor.GREEN,
  SUBMITTED: StatusColor.GREEN,
  PUBLISHED: StatusColor.GREEN,
  UNDER_REVIEW: StatusColor.BLUE,
  REJECTED: StatusColor.RED,
  UNKNOWN: StatusColor.YELLOW,
  ACTIVE: StatusColor.GREEN,
  CLOSED: StatusColor.RED,
  DISABLED: StatusColor.GRAY,
  INACTIVE: StatusColor.GRAY,
  IN_GRACE_PERIOD: StatusColor.BLUE,
};
